import { createType } from 'framework/utils/createType';

export const InventoryItemDetailTabTypes = createType('overview', 'transactions', 'comments');
export type InventoryItemDetailTabType = typeof InventoryItemDetailTabTypes[number];
